const selectLoginUserActionDetails = state => state.data.loginUserActionDetails

const LoginUserActionDetailDataStoreSelectors = {
  loginUserActionDetails: selectLoginUserActionDetails
}

export default LoginUserActionDetailDataStoreSelectors
